<template>
    <div v-if="model.app.id && table && document" class="mb-5 p-3">
        <tab-navigator v-if="!hideTabNavigation" :table="table"></tab-navigator>

        <div v-for="field in table.fields" class="card-text">

            <string-renderer v-if="field.field_type === 'String' && fieldValue(field)" class="mt-4"
                             :field="field" :document="document"></string-renderer>

            <div v-else-if="field.field_type === 'Text' && fieldValue(field)" class="rich-text mb-3">
                <div><strong>{{field.name}}</strong></div>
                <div v-html="fieldValue(field)"></div>
            </div>

            <div v-else-if="field.field_type === 'Boolean'" class="my-3 d-flex align-items-center">
                <div class="me-2"><strong>{{field.name}}</strong></div>
                <checkbox-view :document="document"
                               :field-name="field.index" :editable="false" :key="field.id + 'detailsview'"
                               :table="table" alignment-class="justify-content-left"></checkbox-view>
            </div>

            <select-view v-else-if="field.field_type === 'Single Select'" :document="document"
                         :field="field" class="mb-3"></select-view>

            <div v-else-if="field.field_type === 'Collaborator' && fieldValue(field)" class="my-3">
                {{field.name}}: <span class="badge text-bg-light">{{fieldValue(field).name}}</span>
            </div>

            <div v-else-if="field.field_type === 'Attachment' && fieldValue(field) && fieldValue(field).length > 0" class="my-3">
                {{field.name}}:<br>

                <attachment-viewer :attachments="attachments(field)"
                                   :document="document" :field="field" :table="table"></attachment-viewer>
            </div>

            <div v-else-if="field.field_type === 'Number' && fieldValue(field)" class="mb-3">
                {{field.name}}: {{fieldValue(field)}}
            </div>

        </div>

        <div v-if="linkedObjectField" class="card-text">
            <linked-object-view :child-table-id="linkedObjectField.related_model_id" :parent-table="table"
                                :parent-document="document"></linked-object-view>
        </div>

        <div class="py-2 d-flex">
            <router-link v-if="authorized" :to="{name: 'edit-object', params: {table_id: table.id, document_id: documentId}}"
                         class="btn btn-primary btn-wide me-2">
                Edit
            </router-link>

            <back-button :component="{value: 'Cancel'}"></back-button>
        </div>

    </div>
</template>

<script>
    import ModelService from "../services/ModelService";
    import LinkedObjectView from "./list/LinkedObjectView.vue";
    import SelectView from "../components/SelectView.vue";
    import CheckboxView from "../components/CheckboxView.vue";
    import TabNavigator from "./nav/TabNavigator.vue";
    import AttachmentViewer from "./controls/AttachmentViewer.vue";
    import StringRenderer from "../components/StringRenderer.vue";
    import BackButton from "./buttons/BackButton.vue";

    export default {
        name: 'ShowView',
        props: {
            table_id: String,
            record_id: String,
            parentTable: Object,
            parentDocument: Object
        },
        components: {
            BackButton,
            StringRenderer,
            AttachmentViewer, TabNavigator, CheckboxView, SelectView, LinkedObjectView},
        data () {
            return {
                model: webase.model,
                service: new ModelService(),
                table: null,
                document: null
            }
        },
        computed: {
            authorized() {
                if(webase.managers.permission.fullAccess()) {
                    return true
                }

                return webase.managers.permission.isAuthorized(this.table, this.document, this.parentTable, this.parentDocument)
            },
            linkedObjectField() {
                return webase.utils.table.getLinkedObjectField(this.table)
            },
            documentId() {
                return this.document['id']
            },
            hideTabNavigation() {
                return this.model.app.hide_tab_navigation
            },
            returnRoute() {
                if( this.parentTableId && this.parentDocumentId ) {
                    return { name: 'static-details', params: {table_id: this.parentTableId, record_id:this.parentDocumentId }}
                }

                // return { name: 'list-view', params: {id: this.tableId} }
                return { name: 'view-renderer', params: {id: this.table.views[0].id} }
            },
            returnLabel() {
                if( this.parentTableId && this.parentDocumentId ) {
                    return 'Back'
                }

                return "Return to " + this.table.name + " table"
            }
        },
        mounted () {
            this.service.get(this.table_id).then((response) => {
                this.table = response

                if(!this.model.app.id) {
                    webase.utils.app.loadApp(this.table.app_id)
                }

                this.loadData()
            }).catch((message) => {
                console.log('error loading table')
                console.log(message)
            })
        },
        methods: {
            fieldValue(field) {
                return this.document[field.index]
            },
            loadData() {
                this.service.getDocument(this.table, this.record_id).then((response) => {
                    this.document = response
                }).catch((message) => {
                    console.log('error loading records from table')
                    console.log(message)
                })
            },
            attachments(field) {
                return this.document[field.index] ? this.document[field.index] : []
            }
        }
    }
</script>

<style>

</style>
